"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Cookie = require('cookies-js');

var assign = require('lodash/assign');

var get = require('lodash/get');

var requestError = require('@flowio/request/lib/error');

var requestSuccess = require('@flowio/request/lib/success');

var session = require('./index');

var config = require('./config');

var persistSession = require('./persist-session');

var shouldRefreshSession = require('./should-refresh-session');

var SessionClient = require('./client/index');

var sessionClient = new SessionClient({
  apiBaseUri: config.API_BASE_URI
});

function getErrorMessage(error) {
  if (error && error.messages && error.messages.length) {
    return error.messages.join(', ');
  }

  return '';
}

function upserted(options, data) {
  if (options.onUpserted) {
    options.onUpserted(data);
  }
}
/**
 * Persist session and either call the onSuccess or onError callback.
 *
 * @param  {object} sess    The API session object
 * @param  {object} options
 * @param  {object} options.onSuccess Optional. Callback when persist succeeds.
 * @param  {object} options.onError   Optional. Callback when persist fails.
 */


function persistAndReply(sess, options) {
  try {
    persistSession(sess, options);
  } catch (error) {
    requestError(options, "Could not persist session: ".concat(error.stack));
    return;
  }

  requestSuccess(options, sess);
}
/**
 * Create a new session and persist it.
 *
 * @param  {object} options
 * @param  {object} options.onSuccess Optional. Callback when persist succeeds.
 * @param  {object} options.onError   Optional. Callback when persist fails.
 */


function createNewSession(options) {
  sessionClient.createSession(_objectSpread(_objectSpread({}, options), {}, {
    organizationId: get(options, 'organization'),
    onSuccess: function onSuccess(newSession) {
      persistAndReply(newSession, options);
      upserted(options, newSession);
    },
    onError: function onError(error) {
      requestError(options, "'Could not create session: response[".concat(getErrorMessage(error), "]"));
    }
  }));
}
/**
 * Determine if cookie and localStorage session are out of sync. If so,
 * the session should be fetched from the server.
 *
 * @param {String} fsid - The value of the _f60_session cookie
 * @param {Object} sess - The value of the _f60_session localStorage entry
 */


function shouldFetchSession(fsid, sess) {
  var missingLocalStorage = fsid && !sess;
  var cookieSessionIdMismatch = fsid && sess && fsid !== sess.id;
  return missingLocalStorage || cookieSessionIdMismatch;
}
/**
 * Checks to see if the organization and the session organization match. Provides safety around
 * the params being undefined. Only checks equality if both organization and sess are defined.
 */


function hasOrganizationMismatch(organization, userSession) {
  return organization && userSession && organization !== get(userSession, 'organization');
}
/**
 * Get session id from cookies. If the session is temporary (aka, a session exists in
 * sessionStorage), return the temporary session cookie instead.
 */


function getCookieSessionId() {
  if (session.isTemporarySession()) {
    return Cookie.get(config.COOKIE_SESSION_TEMPORARY_KEY);
  }

  return Cookie.get(config.COOKIE_SESSION_KEY);
}
/**
 * Make sure cookies and session look good. If not, set it up.
 */


function init(opts) {
  var options = assign({
    integration: 'default'
  }, opts);
  /**
   * @constant {Boolean} overrideSession Determines if session is being forcefully overwritten by
   *                                     provided `sessionId` parameter
   */

  var overrideSession = !!opts.sessionId;
  /**
   * @constant {String} fsid The session id. Either provided as an option or from cookies
   */

  var fsid = opts.sessionId ? opts.sessionId : getCookieSessionId();
  /**
   * @constant {Object} userSession The full session object from Storage
   */

  var userSession = session.getSession();
  var organization = options.organization;

  if (!overrideSession && (hasOrganizationMismatch(organization, userSession) || options.forceNewSession)) {
    createNewSession(options);
    return;
  } // Cookie exists but not in storage. Possible that local storage is
  // unavailable.


  if (shouldFetchSession(fsid, userSession)) {
    sessionClient.getSession(_objectSpread(_objectSpread({}, options), {}, {
      sessionId: fsid,
      onSuccess: function onSuccess(existingSession) {
        // Will attempt to store session in localStorage, otherwise will be in
        // memory for the page load.
        persistAndReply(existingSession, options);
      },
      onError: function onError() {
        // Session ID was bad, create a new one.
        createNewSession(options);
      }
    }));
    return;
  }

  if (!fsid || !userSession) {
    createNewSession(options);
    return;
  }

  if (shouldRefreshSession(session.getVisitExpiration())) {
    sessionClient.resetSession(_objectSpread(_objectSpread({}, options), {}, {
      sessionId: userSession.id,
      geo: {
        country: get(userSession, 'geo.country.iso_3166_3'),
        currency: get(userSession, 'geo.currency.iso_4217_3'),
        language: get(userSession, 'geo.language.iso_639_2'),
        locale: get(userSession, 'geo.locale.id')
      },
      experience: get(userSession, 'experience.key'),
      experiment: get(userSession, 'experiment'),
      attributes: get(userSession, 'attributes'),
      onSuccess: function onSuccess(updatedSession) {
        persistAndReply(updatedSession, options);
        upserted(options, updatedSession);
      },
      onError: function onError() {
        createNewSession(options);
      }
    }));
  } else {
    requestSuccess(options, userSession);
  }
}

module.exports = init;


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/session/lib/init.js
// module id = 694
// module chunks = 0 1